import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const LogoSymbol: React.FC<SvgIconProps> = props => {
  return (
    <SvgIcon
      strokeMiterlimit="1.414"
      clipRule="evenodd"
      fillRule="evenodd"
      strokeLinejoin="round"
      viewBox="0 0 1000 1000"
      {...props}
    >
      <g transform="translate(-.007 22.636) scale(.24408)" clipPath="url(#b)">
        <g id="a">
          <path
            d="M2063.16 3110.769c-149.224 46.37-307.787 71.37-472.118 71.37-878.14 0-1591.014-712.93-1591.014-1591.014C.028 712.991 712.902.08 1591.042.08c757.541 0 1392.123 530.592 1552.114 1240.076L2063.159 3110.769zM1591.041 853.18c407.285 0 737.927 330.658 737.927 737.944 0 407.231-330.642 737.927-737.927 737.927-407.286 0-737.928-330.696-737.928-737.927 0-407.286 330.642-737.944 737.928-737.944z"
            fill="#5913ff"
            transform="translate(0 364.653)"
          />
          <path
            d="M3529.241 943.249l567.792 327.815-971.185 1682.145-567.793-327.814z"
            fill="#ffd809"
            transform="translate(0 364.653)"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export default LogoSymbol;
